<template>
  <v-container class="pl-0 pr-0" fluid>
    <v-layout v-if="!applications.length">
      <v-flex xs12>
        <p>{{ $t('admin.applications.list.empty') }}</p>
      </v-flex>
    </v-layout>
    <v-layout v-if="applications.length" wrap>
      <v-flex xs12 sm6 class="mb-4" v-for="application in applications" :key="application._id">
        <v-card
          :to="{ name: 'InstanceView', params: { id: application._id } }"
          class="grey lighten-4 application-card mr-4"
          flat
        >
          <v-card-text>
            <img :src="application.thumbnail" class="mb-3" />
            <h3 class="title mb-2">{{ application.name }}</h3>
            <p v-show="isUserAdmin && application.terminal" class="text mb-0">
              {{ $t('simulator.selector.terminal', { name: application.terminal.name }) }}
            </p>
            <p v-show="isUserAdmin && application.group" class="text">
              {{
                $t('simulator.selector.group', {
                  name: application.group && application.group.name,
                })
              }}
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { presignURL } from '@/auth/utils';
import notifications from '@/utils/notifications';
import axios from 'axios';
import { translateApiError } from '@/utils/apiError';

export default {
  name: 'application-selector',
  data() {
    return {
      applications: [],
    };
  },
  computed: {
    ...mapGetters(['isUserAdmin']),
  },
  async mounted() {
    await this.fetchApplications();
  },
  methods: {
    async fetchApplications() {
      try {
        const { data } = await axios.get('applications?populate=true');
        // Sort by group and name
        data.sort((app1, app2) => {
          const group1 = app1.group && app1.group.name;
          const group2 = app2.group && app2.group.name;
          if (group1 === group2) {
            return app1.name > app2.name ? 1 : -1;
          }
          return group1 > group2 ? 1 : -1;
        });
        this.applications = data;
        await Promise.all(this.applications.map(this.getThumbnail));
      } catch (err) {
        notifications.$emit('error', translateApiError(err, 'errors.loadFailed.applications'));
      }
    },
    async getThumbnail(application) {
      const presignedUrl = await presignURL({ id: application._id, resource: 'applications' });
      this.$set(application, 'thumbnail', presignedUrl);
    },
  },
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}

.application-card img {
  width: 100%;
}
</style>
